var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  if (specialProduct) {
     picker.set('disable', [1,2,3,4,5,6]);
     picker.set('disable', [true, { from: [2020, 10, 8], to: [2022, 8, 23] }]);
     picker.set('max', 100); 
     picker.set('min', 1); 
    
  } else {
    picker.set('disable', blackoutdatesCollection);
  }
}